import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  insertPromobox(event) {
    const promoboxId = parseInt(event.currentTarget.dataset.id);
    window.kraut.MarkdownEditor.appendText(`[farbbox:${promoboxId}]\n`);
  }
}

